import { useState } from "react";
import { useSelector } from "react-redux";
import { downloadPdf } from "../../Actions/FileManagerAction";
import { ServerAddress } from "../../Enum/Urls";

const DownloadDocument = props => {

    const LAN = useSelector(state => state.VisualData.LAN);

    const token = localStorage.getItem("userToken");

    const [loading, setLoading] = useState(false);

    const clickHandle = async () => {
        setLoading(true);
        setLoading(true);

        const response = await downloadPdf({
            Type: props.type,
            ReserveId: props.ReserveId,
            Username: props.Username
        }, {
            LAN: LAN,
            token: token,
            currency: props.currency || "USD"
        });

        if (response?.data?.result) {

            setLoading(false);

            const url = `${ServerAddress.Type}${ServerAddress.PdfGenerator}/File/DownloadTempFile?fileName=${response.data.result.fileName}&fileType=${response.data.result.fileType}&fileToken=${response.data.result.fileToken}`;
            let a = document.createElement('a');
            a.href = url;
            a.click();
        }

    }

    return (
        <button
            onClick={clickHandle}
            type="button"
            className={props.className || "button color-1-btn nowrap margin-start-half"}
        >
            {props.text || "download"}
            {loading ? <span className={`loading-inline-circle margin-start-light ${props.small ? "xxsmall" : "xsmall"}`} /> : null}
        </button>
    )
}

export default DownloadDocument;